import { render, staticRenderFns } from "./RegiaoCadastro.vue?vue&type=template&id=d8059820&lang=html"
import script from "./RegiaoCadastro.vue?vue&type=script&lang=js"
export * from "./RegiaoCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports